import { resources } from "@constants/hardcoded-strings";
import {
    AXNUIContent,
    AXNUILayout,
    AXNUITheme
} from "@iddataweb/idw-common-ui/types";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { ThemingHeaderValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";

export const getThemingHeaderValidationErrors = (
    isUsingThemedUI: boolean,
    axnuiContent: AXNUIContent,
    axnuiLayout: AXNUILayout,
    axnuiTheme: AXNUITheme
): ThemingHeaderValidationErrors => {
    let count = 0;
    let customCssError = null;
    let customHtmlError = null;
    let headerLogoError = null;
    let headerTextError = null;

    if (isUsingThemedUI && axnuiLayout.isHeaderEnabled) {
        if (axnuiTheme.header?.showLogo && !axnuiTheme.header?.useHtmlCss) {
            if (!axnuiTheme.header.logoUrl) {
                count += 1;
                headerLogoError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
            }
        }
        if (axnuiTheme.header?.showText && !axnuiContent.header.text && !axnuiTheme.header?.useHtmlCss) {
            count += 1;
            headerTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (axnuiTheme.header?.useHtmlCss) {
            if (!axnuiContent.header.customCssHeader) {
                count += 1;
                customCssError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
            }
            if (!axnuiContent.header.customHtmlHeader) {
                count += 1;
                customHtmlError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
            }
        }
    }

    return {
        customCssError,
        customHtmlError,
        headerLogoError,
        headerTextError,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.theming.subTabs.header.tabName}
            errorCount={count}
        />
    };
};